(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* Announcement rotator */
  $$('[data-rotator]').forEach(function (track) {
    var items = $$('.announcement__item', track);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* Mobile drawer */
  $$('[data-drawer]').forEach(function (drawer) {
    var close = function () { drawer.removeAttribute('open'); document.body.style.overflow = ''; };
    drawer.addEventListener('toggle', function () { document.body.style.overflow = drawer.open ? 'hidden' : ''; });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.open) close(); });
    $$('a', drawer).forEach(function (a) { a.addEventListener('click', close); });
  });

  /* Quantity steppers */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    var min = parseInt(input.min || '0', 10);
    var bump = function (d) {
      var v = Math.max(min, (parseInt(input.value, 10) || 0) + d);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    $('[data-qty-minus]', wrap).addEventListener('click', function () { bump(-1); });
    $('[data-qty-plus]', wrap).addEventListener('click', function () { bump(1); });
  });

  /* Cart page: auto-update quantities */
  var cartForm = $('#CartForm');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        cartForm.appendChild(hidden);
        cartForm.submit();
      }, 500);
    });
  }

  /* AJAX add to cart */
  var toast = $('#CartToast');
  var toastTimer;
  function showToast() {
    if (!toast) return;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }
  function updateCount() {
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax-cart]') || !window.fetch) return;
    if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (toast && $('.cart-toast__text', toast));
          if (msg) { msg.dataset.default = msg.dataset.default || msg.textContent; msg.textContent = res.data.description || res.data.message; }
          showToast();
          setTimeout(function () { if (msg && msg.dataset.default) msg.textContent = msg.dataset.default; }, 4200);
          return;
        }
        updateCount();
        showToast();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.style.opacity = ''; } });
  });

  /* Product gallery */
  $$('[data-gallery]').forEach(function (gallery) {
    $$('[data-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-thumb');
        $$('.product__slide', gallery).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === id); });
        $$('[data-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  });

  /* Variant picker */
  $$('[data-product-form]').forEach(function (form) {
    var json = $('[data-variants]', form);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var selects = $$('[data-option-index]', form);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var label = $('[data-add-label]', form);
    var defaultLabel = label ? label.textContent.trim() : '';
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var values = selects.map(function (s) { return s.value; });
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === values[i]; }); });
        if (!match) { addBtn.disabled = true; return; }
        idInput.value = match.id;
        addBtn.disabled = !match.available;
        if (label) label.textContent = match.available ? defaultLabel : (document.documentElement.lang === 'fr' ? 'Complet' : 'Sold out');
        var url = window.location.pathname + '?variant=' + match.id;
        window.history.replaceState({}, '', url);
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-price]');
          var current = document.querySelector('[data-price]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
        if (match.featured_media) {
          var thumb = document.querySelector('[data-thumb="' + match.featured_media.id + '"]');
          if (thumb) thumb.click();
        }
      });
    });
  });

  /* Collection sort */
  $$('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', select.value);
      window.location.search = params.toString();
    });
  });

  /* Product recommendations */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      });
  });

  /* Customer login: toggle recover form */
  var recover = $('#RecoverPassword');
  if (recover) {
    var login = $('#CustomerLogin');
    var toggle = function (e) { if (e) e.preventDefault(); recover.hidden = !recover.hidden; login.hidden = !recover.hidden; };
    $$('[data-toggle-recover]').forEach(function (a) { a.addEventListener('click', toggle); });
    if (window.location.hash === '#recover') toggle();
  }

  /* Reveal on scroll */
  if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
    var targets = $$('.section-head, .card, .step, .timeline__item, .panel, .course, .accordion__item, .trust__item, .split__media, .stage-hero__media, .price-card, .cta');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el, i) {
      el.setAttribute('data-reveal', '');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }
})();
